import axios from "axios";
import utils from "@/services/utils";

export default {
  async search(searchOptions) {
    try {
      const response = await axios.get("/report/", {
        params: {
          ...utils.buildApiSearchQuery(searchOptions, "email", false),
          start_date: searchOptions.startDate,
          end_date: searchOptions.endDate,
          incident_nature: searchOptions.incidentNature.join(";"),
          species: searchOptions.species.join(";")
        },
      });
      const data = response.data;
      return { message: "Got reports", data: data.items, total: data.total };
    } catch (e) {
      return { message: "No reports found", data: [], total: 0 };
    }
  }
};
